var TorsoCollection = require('backbone-torso/modules/Collection');
var SurveyItemModel = require('./SurveyItemModel');
var urls = require('./../urls');

/**
 * Collection of surveyItemModels.
 *
 * @class surveyItemCollection
 * @constructor
 */
module.exports = new (TorsoCollection.extend({
  model: SurveyItemModel,
  url: urls.surveyItemTakingServiceImpl,
  fetchHttpAction: 'POST'
}))();
